import {
  AlertTriangle,
  CheckCircle,
  XCircle
} from 'lucide-react'
import React from 'react'

import { Badge, Tooltip } from 'slab'

interface StateStatusBadgeProps {
  available?: boolean
  lastModified?: string | null
  needsReingestion?: boolean
  isUpToDate?: boolean
}

export const StateStatusBadge: React.FC<StateStatusBadgeProps> = ({ available, lastModified, needsReingestion, isUpToDate }) => {
  if (available === undefined) {
    return (
      <Tooltip content='S3 status not yet checked'>
        <Badge type='slate'>
          Not Checked
        </Badge>
      </Tooltip>
    )
  }

  if (!available) {
    return (
      <div className='flex flex-col items-center gap-1'>
        <Tooltip content='File Not Available from Ideon S3'>
          <Badge type='critical' leftIcon={XCircle}>
            File Not Found
          </Badge>
        </Tooltip>
      </div>
    )
  }

  const formattedLastModified = lastModified ? new Date(lastModified).toLocaleDateString() + ' ' + new Date(lastModified).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : null
  if (needsReingestion) {
    return (
      <div className='flex flex-col items-center gap-1'>
        <Tooltip content={lastModified ? `File updated: ${formattedLastModified}` : 'Update Available'}>
          <Badge type='warning' leftIcon={AlertTriangle}>
            Update Available
          </Badge>
        </Tooltip>
      </div>
    )
  }

  if (isUpToDate) {
    return (
      <div className='flex flex-col items-center gap-1'>
        <Tooltip content='Local data is up to date with S3'>
          <Badge type='info' leftIcon={CheckCircle}>
            Up to Date
          </Badge>
        </Tooltip>
      </div>
    )
  }

  return (
    <div className='flex flex-col items-center gap-1'>
      <Tooltip content={lastModified ? `File updated: ${formattedLastModified}` : 'File Available'}>
        <Badge type='success' leftIcon={CheckCircle}>
          File Available
        </Badge>
      </Tooltip>
    </div>
  )
}
